// extracted by mini-css-extract-plugin
export default {"placeholder":"EmptyTablePlaceholder_placeholder__8dY6-"};